<script>
  /**
   * @overview 课时管理 - 入口列表
   *
   * @author
   */

  import mapUtils, { $list, $http } from "@/utils";
  import store from "@/store";
  import { mapState } from "vuex";
  import CourseItem from "../Course/components/ListItem.vue";
  import CourseEditor from "../Course/components/ListEditor.vue";

  export default {
    name: "SceneList",

    components: {
      CourseItem,
      CourseEditor,
    },

    data: () => ({
      unitList: [],
      unitVisible: false,
      inputVisible: false,
      inputValue: "",
      loading: false,

      list: {
        data: [],
      },

      query: {
        per_page: 20,
      },

      structureProps: {
        children: "leaf",
        value: "id",
        label: "name",
      },

      editor: {
        data: null,

        visible: false,
      },
    }),

    computed: {
      ...mapState("course", ["subjects", "structure", "themes"]),

      subjectValue() {
        return Number(this.$route.query.subject);
      },

      structureValue() {
        return this.$route.query.structure.split(",").map(id => Number(id));
      },
    },

    beforeRouteEnter(to, from, next) {
      const { query } = to;
      const {
        state: { course },
      } = store;

      const subject = query.subject || course.subjects[0].id;

      store.dispatch("course/initStructure", subject).then((structure) => {
        const condition = $list.routeQuery(
          {
            page: 1,
            structure,
            subject,
          },
          to.query,
        );

        query.subject && query.structure
          ? next()
          : next({ ...to, query: condition });
      });
    },

    created() {
      this.themes.length || this.$store.dispatch("course/initThemes");

      this.fetchList();
      this.getUnitList();
    },

    beforeRouteUpdate(to, from, next) {
      this.fetchList(to);

      next();
    },

    methods: {
      ...mapUtils("list", [
        "deleteAlert",
        "fetch",
        "routeQuery",
        "routePageIndex",
      ]),
      getUnitList() {
        $http.get("/unit").then((res) => {
          this.unitList = res;
        });
      },
      submitUnitList() {
        this.unitVisible = false;
        this.getUnitList();
      },
      handleClose(tag) {
        this.unitList.splice(this.unitList.indexOf(tag), 1);
        $http.delete(`/unit/${tag.id}`).then((res) => {
          this.$message.success("删除成功");
        });
      },

      showInput() {
        this.inputVisible = true;
        this.$nextTick((_) => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirm() {
        const val = {
          name: this.inputValue,
        };
        if (this.inputValue) {
          $http.post("/unit", val).then((res) => {
            this.getUnitList();
          });
        }
        this.inputVisible = false;
        this.inputValue = "";
      },

      fetchList(route = this.$route) {
        const { structure, ...rest } = route.query;

        const query = {
          ...rest,
          ...this.query,
          "equal[structure_id]": this.resolveStructureID(structure),
        };

        this.$list_fetch("/course", query).then((data) => {
          this.list = data;
        });
      },

      queryName(nameQuery) {
        this.query = { ...this.query, ...nameQuery };

        const query = { page: 1, ...this.query };

        this.$list_routeQuery(query);
      },

      querySubject(subject) {
        this.$store
          .dispatch("course/initStructure", Number(subject))
          .then((structure) => {
            const query = {
              ...this.query,
              subject,
              structure,
              page: 1,
            };

            this.$list_routeQuery(query);
          });
      },

      queryStructure(value) {
        const query = {
          ...this.query,
          structure: value.toString(),
          page: 1,
        };

        this.$list_routeQuery(query);
      },

      resolveStructureID(structure) {
        return structure.split(",").pop();
      },

      editorLoad(id) {
        const prepare = id ? $http.get(`/course/${id}`) : Promise.resolve(null);

        prepare
          .then((res) => {
            this.editor.data = res;
          })
          .then(() => {
            this.editor.visible = true;
          });
      },

      editorResponse(id) {
        id || Number(this.$route.query.page) === 1
          ? this.fetchList()
          : this.$list_routePageIndex(1, this.route);
      },

      courseDelete(id) {
        this.$list_deleteAlert(id, this.list.data, "课时", "/course");
      },

      coursePreview(id, structure_id) {
        this.$router.push(`/course/${id}/${structure_id}`);
      },
    },
  };
</script>

<template>
  <div
    v-loading="loading"
    class="course-list">
    <div class="search-box">
      <el-input
        class="btn-search"
        type="text"
        placeholder="场景名称搜索"
      />
      <el-button type="primary">搜索</el-button>
    </div>
    <AppList>
      <!--<AppLabel-->
      <!--class="course-list__item"-->
      <!--width="240px"-->
      <!--@create="editorLoad" />-->

      <CourseItem
        v-for="item in list.data"
        :key="item.id"
        :data="item"
        class="course-list__item"
        @delete="courseDelete"
        @preview="coursePreview"
        @update="editorLoad"
      />
    </AppList>

    <CourseEditor
      :visible.sync="editor.visible"
      :data="editor.data"
      :type="Number($route.query['equal[type]'])"
      @success="editorResponse"
    />

    <TheFooter>
      <el-select
        :value="subjectValue"
        size="small"
        class="course-list__subject"
        @change="querySubject"
      >
        <el-option
          v-for="subject in subjects"
          :key="subject.id"
          :label="subject.name"
          :value="subject.id"
        />
      </el-select>

      <el-cascader
        :value="structureValue"
        :options="structure"
        :props="structureProps"
        class="course-list__structure"
        size="small"
        placeholder="请选择学科以及对应课时"
        @change="queryStructure"
      />

      <AppPagination
        :list="list"
        :size="query.per_page"
        class="course-list__pagination"
        router />
      <el-button
        class="addUnit"
        size="small"
        @click="unitVisible=true">添加单元</el-button>
      <AppQueryName
        :value="$route.query['like[name]']"
        @query="queryName" />
    </TheFooter>
    <el-dialog
      :visible="unitVisible"
      :show-close="false"
      width="1000px"
      class="course-list-editor">
      <div slot="title">
        单元维护
      </div>
      <el-tag
        v-for="tag in unitList"
        :key="tag.id"
        :disable-transitions="false"
        closable
        @close="handleClose(tag)"
      >{{ tag.name }}</el-tag>
      <el-input
        v-if="inputVisible"
        ref="saveTagInput"
        v-model="inputValue"
        class="input-new-tag"
        size="small"
        @keyup.enter.native="handleInputConfirm"
        @blur="handleInputConfirm"
      />
      <el-button
        v-else
        class="button-new-tag"
        size="small"
        @click="showInput">点击添加标签</el-button>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="unitVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitUnitList">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style lang="postcss" scoped>
    .search-box{
      display: flex;
      flex-direction: row;
      padding: 30px;
      padding-bottom: 0px;
    }
    .btn-search{
      width: 200px;
      margin-right: 10px;
    }
    .el-tag {
        margin-left: 10px;
    }
    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }
    .addUnit {
        margin-right: 20px;
    }
    .course-list {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
    }

    .course-list__item {
        margin: 15px 14px;
    }

    .course-list .module-list-item-label {
        flex-shrink: 0;
    }

    .course-list__subject {
        width: 10em;
    }

    .course-list__structure {
        margin: 0 auto 0 1em;
        width: 20em;
    }

    .course-list__pagination {
        margin: 0 auto 0 -15em;
    }
</style>
